import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import * as myGlobals from '../../globals';
import 'rxjs/Rx';
import { ConfigService } from '../../config.service';

@Injectable()
export class BookingPopupService {

  constructor() { }

}



// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/booking-popup/booking-popup.service.ts